/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.filtercontent', function (el) {
        var config = {
            items: el.querySelectorAll('.filter__card'),
        };
        FilterContent.create(config);
    });
    var FilterContent = /** @class */ (function () {
        function FilterContent(config) {
            this.items = config.items;
        }
        FilterContent.create = function (config) {
            return new FilterContent(config).run();
        };
        FilterContent.prototype.run = function () {
            this.setMinWithForCards();
            this.watchDropdownHeight();
        };
        FilterContent.prototype.setMinWithForCards = function () {
            this.items.forEach(function (item) {
                var itemsDiv = item.querySelector('.items .itemInner');
                if (itemsDiv.scrollHeight >= 200) {
                    item.querySelector('.items').classList.add('largeList');
                }
            });
        };
        FilterContent.prototype.watchDropdownHeight = function () {
            function ready(fn) {
                if (document.readyState !== 'loading') {
                    fn();
                }
                else {
                    document.addEventListener('DOMContentLoaded', fn);
                }
            }
            ready(function () {
                setTimeout(function () {
                    var listOptions = document.querySelectorAll('#moya-select-pnrs-list li');
                    listOptions.forEach(function (item) {
                        item.addEventListener('click', function (evt) {
                            var target = evt.target;
                            window.location.href = target.id.replace('moya-select-pnrs-', '');
                        });
                    });
                }, 300);
            });
        };
        return FilterContent;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
